import { Create } from 'react-admin';
import LanguageExamForm from './LanguageExamForm';

const LanguageExamCreate = () => (
  <Create>
      <LanguageExamForm />
  </Create>
);

export default LanguageExamCreate;